import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootHeader: {
				display: "flex",
				height: 50,
				alignItems: "center",
				justifyContent: "center",
				borderBottom: `1px solid ${theme.palette.grey[700]}`
			},
			titleHeader: {
				fontWeight: 600,
				fontSize: 18
			},
			btnClose: {
				position: "absolute",
				right: 0
			},
			root: {
				padding: "16px"
			},
			title: {
				color: theme.palette.primary.contrastText,
				fontSize: 20,
				fontWeight: 500,
				marginTop: 40
			},
			subTitle: {
				color: theme.palette.primary.contrastText,
				fontSize: 14,
				marginTop: 5
			},
			textArea: {
				border: `1px solid ${theme.palette.grey[800]}`,
				borderRadius: 6,
				marginTop: 10,
				width: "100%",
				"& > .MuiInput-underline:before": {
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`,
					content: "none"
				},
				"& > .MuiInput-underline:after": {
					content: "none",
					borderBottom: `1px solid ${theme.palette.grey["A100"]}`
				},
				"& > div > textarea": {
					color: theme.palette.primary.contrastText,
					height: 37,
					backgroundColor: theme.palette.grey["A100"],
					fontSize: 18,
					lineHeight: "21px",
					padding: "3px 10px"
				}
			},
			btnSubmit: {
				background: theme.palette.primary.main,
				marginTop: 20,
				borderRadius: 6,
				color: theme.palette.text.contrastText,
				width: 167,
				textAlign: "center",
				padding: 10,
				cursor: "pointer",
				"& > active": {
					opacity: 0.7,
					transition: "width 2s",
					background: theme.palette.primary.main
				}
			}
		}),
	{
		name: "FeedBackPage",
		index: 1
	}
);

export default useStyles;
